import { FormControl, FormHelperText, TextField } from "@material-ui/core";
import React, { memo, useEffect } from "react";
import { Field } from "features/admin/Products/types";
import { useStyles } from "./styles";
import { Controller } from "react-hook-form";
import { useState } from "react";

interface TextInputFieldProps {
  item: Field;
  control: any;
  reset: boolean;
  setValue: any;
  textRef?: React.MutableRefObject<string>;
  errors?: any;
  value?: string;
}

export const TextInputField: React.FC<TextInputFieldProps> = ({
  item,
  control,
  reset,
  setValue,
  textRef,
  errors,
  value,
}) => {
  const classes = useStyles();
  useEffect(() => {
    setValue(item.name, item.value);
  }, []);

  return (
    <FormControl required={item.required} className={classes.formControl}>
      <Controller
        name={item.name}
        defaultValue={""}
        rules={item.rules}
        render={({ onChange, name }) => (
          <TextInputWrapper
            name={name}
            label={item.title}
            value={item.value}
            onChange={onChange}
            required={item.required}
            textRef={textRef}
            errors={errors}
          />
        )}
        control={control}
      />
      {item.required && <FormHelperText>Задължително</FormHelperText>}
    </FormControl>
  );
};

export default memo(TextInputField);

interface Props {
  value?: string;
  name: string;
  label: string;
  onChange: any;
  required: boolean;
  textRef?: React.MutableRefObject<string>;
  errors: any;
}

export const TextInputWrapper: React.FC<Props> = ({
  name,
  label,
  value,
  onChange,
  required,
  textRef,
  errors,
}) => {
  const [text, setText] = useState(value ? value : "");
  const handleChange = (event: any, onChange: any) => {
    setText(event.target.value);
    onChange(event.target.value);
    if (textRef && textRef.current !== undefined) {
      textRef.current = event.target.value;
    }
  };
  const helperText = errors && errors[name] ? errors[name].message : "";
  const error = errors ? !!errors[name] : false;

  return (
    <>
      {name.includes("description") || name.includes("content") ? (
        <TextField
          id={name}
          label={label}
          name={name}
          required={required}
          multiline
          value={text}
          rows={13}
          onChange={(e) => handleChange(e, onChange)}
        />
      ) : (
        <TextField
          id={name}
          name={name}
          required={required}
          label={label}
          onChange={(e) => handleChange(e, onChange)}
          value={text}
          helperText={helperText}
          error={error}
        />
      )}
      {name.includes("Meta") && <div>{text.length}</div>}
    </>
  );
};
